export default {
    listagem: {
        titulo_pagina: 'Lista de Protocolos',
        novo: 'Criar novo Protocolo',
        table: {
            empty: 'Nenhum Protocolo encontrado',
            nome: 'Nome',
            classe: 'Classe',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create new Protocol',
            editar: 'Edit Protocol'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Protocol Name'
            },
            classe: {
                label: 'Class',
                description: 'Class that executes the Protocol'
            },
            status: {
                label: 'Status',
                description: 'Protocol active or inactive status'
            },
            has_protocol_settings: {
                label: 'Protocol Configuration',
                description: 'Configuration for generic protocol.'
            },
            protocol_settings: {
                label: 'Configuration Name',
                description: 'Configuration to automate extraction of requests and results from the protocol.'
            },
            botao_salvar : 'Salve Protocol'
        },
        create: {
            success: 'Protocol created successfully!',
            error: 'Error creating protocol!'
        },
        update: {
            success: 'Protocol successfully edited!',
            error: 'Error editing protocol!'
        }
    }
}
